const UseFormFocusUtils = module.exports = {};

UseFormFocusUtils.buildFocusStateChange = ({
    focusedStateKey,
    isFocused
}) => {

    return {
        [focusedStateKey]: isFocused
    };
};

UseFormFocusUtils.buildFieldFocusAction = ({
    focusedStateKey,
    field,
    isFocused
}) => {

    return {
        state: UseFormFocusUtils.buildFocusStateChange({
            focusedStateKey,
            isFocused
        }),
        hideErrorField: field,
        hideErrorShow: isFocused ? false : undefined
    };
};
